<template>
  <div class="contactdetails">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div
      class="container mobile-hide"
      style="
    height: 150px;
    background: url(./img/careforsociety_bottom.png)center center /cover;
    transform: scaleX(-1);"
    ></div>
    <div class="container" style="text-align:left;margin-bottom:16px;margin-top:20px;">
      <div class="columns">
        <div class="column" style="padding-bottom:0; font-size:48px;">
          <span class="title-size mobile-padding">{{$t('body.contact_details_title')}}</span>
        </div>
      </div>
    </div>
    <div class="container mobile-padding">
      <div class="columns">
        <div class="column mobile-column-padding-right mobile-column-padding-bottom">
          <div class="panel">
            <div class="panel-heading" style="text-align:left;">{{$t('body.contact_klplant')}}</div>
            <div class="googleMapApi_wrapper">
              <div class="googleMapApi" id="kl_googleMap"></div>
            </div>
            <div class="panel-body bodygrey">
              <h4
                style="text-align:left;font-weight:900; font-family:AvenirBold;color:#013d57;"
              >{{$t('body.contact_klfactory')}}</h4>
              <p style="text-align:left;">
                Lot 1013-B, Jalan 2/32A, 6 ½ Miles,
                <br />Kepong Industrial Area, Jalan Kepong,
                <br />52100 Kuala Lumpur, Malaysia
              </p>
              <table>
                <tr>
                  <td width="10" style="font-weight:900; font-family:AvenirBold;color:#013d57;">T</td>
                  <td width="15" align="center">:</td>
                  <td>+603 6258 5552 / +603 6258 1985</td>
                </tr>
                <tr>
                  <td style="font-weight:900; font-family:AvenirBold;color:#013d57;">F</td>
                  <td align="center">:</td>
                  <td>+603 6251 8766</td>
                </tr>
                <tr>
                  <td style="font-weight:900; font-family:AvenirBold;color:#013d57;">E</td>
                  <td align="center">:</td>
                  <td>zantat@zantat.com.my</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="column">
          <div class="panel">
            <div class="panel-heading" style="text-align:left;">{{$t('body.contact_ipohplant')}}</div>
            <div class="googleMapApi_wrapper">
              <div class="googleMapApi" id="ipoh_googleMap"></div>
            </div>
            <div class="panel-body bodygrey">
              <h4
                style="text-align:left;font-weight:900; font-family:AvenirBold;color:#013d57;"
              >{{$t('body.contact_ipohfactory')}}</h4>
              <p style="text-align:left;">
                PT24571 &amp; PT21289, Kaw. Industri
                <br />Batu Kapur Keramat Pulai, 31300
                <br />Kampung Kepayang, Perak, Malaysia.
              </p>
              <table>
                <tr>
                  <td width="10" style="font-weight:900; font-family:AvenirBold;color:#013d57;">T</td>
                  <td width="15" align="center">:</td>
                  <td>+605 357 1853 / +605 357 1463</td>
                </tr>
                <tr>
                  <td style="font-weight:900; font-family:AvenirBold;color:#013d57;">F</td>
                  <td align="center">:</td>
                  <td>+605 3571407</td>
                </tr>
                <tr>
                  <td style="font-weight:900; font-family:AvenirBold;color:#013d57;">E</td>
                  <td align="center">:</td>
                  <td>zantat@zantat.com.my</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="position:relative;top:50px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "contactdetails",

  mounted() {
    let self = this;
    console.log("contactdetails");
    self.kl_googleMap();
    self.ipoh_googleMap();
  },
  methods: {
    kl_googleMap() {
      var myCenter = new google.maps.LatLng(3.2065026, 101.6532129);
      var markerPoint = new google.maps.LatLng(3.2065026, 101.6532129);
      var marker;
      var mapProp = {
        center: myCenter,
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      var map = new google.maps.Map(
        document.getElementById("kl_googleMap"),
        mapProp
      );
      marker = new google.maps.Marker({
        position: markerPoint
        //animation:google.maps.Animation.BOUNCE
      });

      marker.setMap(map);

      google.maps.event.addDomListener(window, "load", kl_googleMap);
    },
    ipoh_googleMap() {
      var myCenter = new google.maps.LatLng(4.5299752, 101.154502);
      var markerPoint = new google.maps.LatLng(4.5299752, 101.154502);
      var marker;
      var mapProp = {
        center: myCenter,
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };

      var map = new google.maps.Map(
        document.getElementById("ipoh_googleMap"),
        mapProp
      );
      marker = new google.maps.Marker({
        position: markerPoint
        //animation:google.maps.Animation.BOUNCE
      });

      marker.setMap(map);

      google.maps.event.addDomListener(window, "load", ipoh_googleMap);
    }
  }
};
</script>


<style lang="scss" scoped>
.googleMapApi_wrapper {
  position: relative;
  margin-bottom: 15px;
}
.googleMapApi_wrapper .googleMapApi {
  height: 300px;
}
.panel-heading {
  background-color: #013d57;
  border-radius: 0;
  color: white;
  font-size: 1.25em;
  font-weight: 600;
  line-height: 1.25;
  padding: 0.5em 0.75em;
}
</style>
